module.exports = __webpack_public_path__ + "static/media/banner-phone.537c5d2f.png";